import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ExpandIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M21 14a1 1 0 011 1v4a3 3 0 01-3 3h-4a1 1 0 010-2h4a1 1 0 001-1v-4a1 1 0 011-1zM3 14a1 1 0 011 1v4a1 1 0 001 1h4a1 1 0 010 2H5a3 3 0 01-3-3v-4a1 1 0 011-1zM19 2a3 3 0 012.995 2.824L22 5v4a1 1 0 01-1.993.117L20 9V5a1 1 0 00-.883-.993L19 4h-4a1 1 0 01-.117-1.993L15 2h4zM9 2a1 1 0 110 2H5a1 1 0 00-1 1v4a1 1 0 11-2 0V5a3 3 0 013-3h4z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
ExpandIcon.isCarinaIcon = true;
export default ExpandIcon;
